import { AssetSection } from "features/organizations/asset-sections/models/asset-section-models"
import { Asset } from "features/organizations/assets/models/asset-models"
import { Customer } from "features/organizations/customers/models/customer-models"
import { Site } from "features/organizations/sites/models/sites-models"
import { ProvisionEvent } from "features/provisioning/provisions/models/provision-models"

const HEAD_URL = "/provision-events"

type Nullish = null | undefined

export const provisionEventsLinkGenerator = (
    customer?: Customer | Nullish,
    site?: Site | Nullish,
    asset?: Asset | Nullish,
    assetSection?: AssetSection | Nullish,
    event?: ProvisionEvent | { id: string | Nullish } | Nullish,
    additional?: string,
) => {
    if (customer) {
        if (site) {
            if (asset) {
                if (assetSection) {
                    if (event && event.id) {
                        return `${HEAD_URL}/customer/${customer.id}/site/${site.id}/asset/${asset.id}/assetsection/${assetSection.id}/event/${
                            event.id
                        }${additional || ""}`
                    }
                    return `${HEAD_URL}/customer/${customer.id}/site/${site.id}/asset/${asset.id}/assetsection/${assetSection.id}`
                }
                return `${HEAD_URL}/customer/${customer.id}/site/${site.id}/asset/${asset.id}`
            }
            return `${HEAD_URL}/customer/${customer.id}/site/${site.id}`
        }
        return `${HEAD_URL}/customer/${customer.id}`
    }
    return HEAD_URL
}

export const provisionEventsLinkGeneratorSimple = (
    customerId?: string | undefined,
    siteId?: string | undefined,
    assetId?: string | undefined,
    assetSectionId?: string | undefined,
    eventId?: string | undefined,
    additional?: string,
) => {
    if (customerId) {
        if (siteId) {
            if (assetId) {
                if (assetSectionId) {
                    if (eventId) {
                        return `${HEAD_URL}/customer/${customerId}/site/${siteId}/asset/${assetId}/assetsection/${assetSectionId}/event/${eventId}${
                            additional || ""
                        }`
                    }
                    return `${HEAD_URL}/customer/${customerId}/site/${siteId}/asset/${assetId}/assetsection/${assetSectionId}`
                }
                if (eventId) {
                    return `${HEAD_URL}/customer/${customerId}/site/${siteId}/asset/${assetId}/event/${eventId}${additional || ""}`
                }
                return `${HEAD_URL}/customer/${customerId}/site/${siteId}/asset/${assetId}`
            }
            return `${HEAD_URL}/customer/${customerId}/site/${siteId}`
        }
        return `${HEAD_URL}/customer/${customerId}`
    }
    return HEAD_URL
}
